import * as Yup from 'yup';

export const YNEFIBranchSelectionValidation = Yup.object()
  .shape({
    isEnergyActive: Yup.boolean(),
    isGasActive: Yup.boolean(),
  })
  .test('checkAtLeastOneBranchSelected', null, (obj) => {
    if (obj.isEnergyActive || obj.isGasActive) {
      return true;
    }

    return new Yup.ValidationError(
      'Wählen Sie mindestens eine Sparte aus.',
      null,
      'noBranchSelected'
    );
  });
